/**
 * Dual-handle price range slider
 * Injects slider UI before <price-range> elements and syncs to Dawn's text inputs.
 */
(function () {
  function parseMoney(str) {
    if (!str) return 0;
    return parseFloat(String(str).replace(/[^0-9.]/g, '')) || 0;
  }

  function formatPrice(val) {
    val = Math.round(val);
    var symbol = window.shopCurrency ? window.shopCurrency.symbol : '\u20B9';
    return symbol + val.toLocaleString('en-IN');
  }

  function initSliders() {
    document.querySelectorAll('price-range.facets__price').forEach(function (priceRange) {
      // Skip if already initialized and slider still exists in DOM
      if (priceRange.dataset.sliderInit === 'true') {
        var existing = priceRange.previousElementSibling;
        if (existing && existing.classList.contains('price-slider')) return;
        priceRange.dataset.sliderInit = '';
      }
      priceRange.dataset.sliderInit = 'true';

      var inputs = priceRange.querySelectorAll('input');
      if (inputs.length < 2) return;

      var minInput = inputs[0];
      var maxInput = inputs[1];
      var maxPrice = Math.ceil(parseMoney(maxInput.getAttribute('data-max')));
      if (maxPrice <= 0) maxPrice = 10000;
      var currentMin = parseMoney(minInput.value);
      var currentMax = parseMoney(maxInput.value);
      if (currentMax <= 0) currentMax = maxPrice;

      var minPct = (currentMin / maxPrice) * 100;
      var maxPct = (currentMax / maxPrice) * 100;

      var slider = document.createElement('div');
      slider.className = 'price-slider';
      slider.innerHTML =
        '<div class="price-slider__labels">' +
          '<span class="price-slider__val price-slider__val--min">' + formatPrice(currentMin) + '</span>' +
          '<span class="price-slider__val price-slider__val--max">' + formatPrice(currentMax) + '</span>' +
        '</div>' +
        '<div class="price-slider__track-wrap">' +
          '<div class="price-slider__track">' +
            '<div class="price-slider__fill" style="left:' + minPct + '%;right:' + (100 - maxPct) + '%;"></div>' +
          '</div>' +
          '<input type="range" class="price-slider__range price-slider__range--min" min="0" max="' + maxPrice + '" value="' + currentMin + '" step="1" aria-label="Minimum price">' +
          '<input type="range" class="price-slider__range price-slider__range--max" min="0" max="' + maxPrice + '" value="' + currentMax + '" step="1" aria-label="Maximum price">' +
        '</div>';

      priceRange.parentNode.insertBefore(slider, priceRange);

      var rangeMin = slider.querySelector('.price-slider__range--min');
      var rangeMax = slider.querySelector('.price-slider__range--max');
      var fill = slider.querySelector('.price-slider__fill');
      var labelMin = slider.querySelector('.price-slider__val--min');
      var labelMax = slider.querySelector('.price-slider__val--max');

      function updateFill() {
        var lo = parseFloat(rangeMin.value);
        var hi = parseFloat(rangeMax.value);
        var max = parseFloat(rangeMin.max);
        fill.style.left = (lo / max) * 100 + '%';
        fill.style.right = (100 - (hi / max) * 100) + '%';
        labelMin.textContent = formatPrice(lo);
        labelMax.textContent = formatPrice(hi);
      }

      function syncAndSubmit() {
        var lo = parseFloat(rangeMin.value);
        var hi = parseFloat(rangeMax.value);
        minInput.value = lo > 0 ? lo : '';
        maxInput.value = hi < maxPrice ? hi : '';
        // Dawn's FacetFiltersForm listens for 'input' events on the form
        minInput.dispatchEvent(new Event('input', { bubbles: true }));
      }

      rangeMin.addEventListener('input', function () {
        if (parseFloat(rangeMin.value) > parseFloat(rangeMax.value)) {
          rangeMin.value = rangeMax.value;
        }
        updateFill();
      });

      rangeMax.addEventListener('input', function () {
        if (parseFloat(rangeMax.value) < parseFloat(rangeMin.value)) {
          rangeMax.value = rangeMin.value;
        }
        updateFill();
      });

      rangeMin.addEventListener('change', function () {
        syncAndSubmit();
      });

      rangeMax.addEventListener('change', function () {
        syncAndSubmit();
      });

      // Ensure text inputs are visually hidden (CSS handles this for vertical mode)
      priceRange.style.position = 'absolute';
      priceRange.style.width = '1px';
      priceRange.style.height = '1px';
      priceRange.style.overflow = 'hidden';
      priceRange.style.clip = 'rect(0,0,0,0)';
    });
  }

  // Init when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
  } else {
    initSliders();
  }

  // Re-init after Shopify AJAX filter updates (debounced)
  var debounceTimer;
  var observer = new MutationObserver(function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      requestAnimationFrame(initSliders);
    }, 250);
  });

  function observeFilters() {
    var target = document.getElementById('main-collection-filters') || document.getElementById('FacetFiltersForm');
    if (target) {
      observer.observe(target, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeFilters);
  } else {
    observeFilters();
  }
})();
